import React, { Component, Fragment } from 'react'
import get from 'lodash/get'

const getOneTrustContainerKey = () => {
    return process.env.REACT_APP_COMPONENT_ONE_TRUST_SCRIPT_KEY
}

class OneTrustWrapper extends Component {
  constructor(props) {
		super(props)

    this.state = {
      oneTrustProviderLoaded: false
    }

    this.handleOneTrustCrossDomainConsent = this.handleOneTrustCrossDomainConsent.bind(this)
    this.onOneTrustLoaded = this.onOneTrustLoaded.bind(this)
  }

  componentDidMount() {
    if (!!window.OneTrust) {
      this.onOneTrustLoaded()
    } else {
      window.addEventListener(
        'one-trust-loaded',
        this.onOneTrustLoaded,
        {
          once: true,
        }
      )
    }

    const oneTrustContainerCode = getOneTrustContainerKey()
    if (oneTrustContainerCode) {
      const oneTrustScript = document.createElement('script')
      oneTrustScript.setAttribute('data-domain-script', oneTrustContainerCode)
      oneTrustScript.charset = 'UTF-8'
      oneTrustScript.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js'
      oneTrustScript.type = 'text/javascript'
      document.head.appendChild(oneTrustScript)
      const eventDispatchScript = document.createElement('script')
      eventDispatchScript.type = 'text/javascript'
      eventDispatchScript.innerHTML = `function OptanonWrapper() {
        var event = new Event('one-trust-loaded');
        window.dispatchEvent(event);
      }`
      document.head.appendChild(eventDispatchScript)
    }
  }

  componentDidUpdate(_, prevState) {
    const { oneTrustProviderLoaded: prevIsLoaded } = prevState
    const { oneTrustProviderLoaded: currIsLoaded } = this.state
    if (!prevIsLoaded && currIsLoaded) {
      this.handleOneTrustCrossDomainConsent()
    }
  }

  componentWillUnmount() {
    window.removeEventListener('one-trust-loaded', this.onOneTrustLoaded)
  }

  handleOneTrustCrossDomainConsent() {
    const url = new URL(window.location.href);
    const identifier = url.searchParams.get('identifier');
    const domain = url.searchParams.get('domain');
    const oneTrustActiveGroups = url.searchParams.get('oneTrustActiveGroups');

    if (oneTrustActiveGroups && identifier && domain) {
      // If the banner is shown
      if (!window.OneTrust.IsAlertBoxClosed()) {
        window.OneTrust.setDataSubjectId(identifier);
        const cookieCategoryGroups = get(window.OneTrust.GetDomainData(), 'Groups');
        const purposes = [];
        Array.from(cookieCategoryGroups).forEach((cookieCategoryGroupsItem) => {
          // in the Domain Data JSON the OptanonGroupId is expressed in C00X
          if (
            oneTrustActiveGroups.includes(
              get(cookieCategoryGroupsItem, 'OptanonGroupId')
            ) &&
            get(cookieCategoryGroupsItem, 'OptanonGroupId') !== 'C0001'
          ) {
            const purposeId = get(cookieCategoryGroupsItem, 'PurposeId');
            const purpose = { Id: purposeId, TransactionType: 'CONFIRMED' };
            purposes.push(purpose);
          }
        });

        if (window.Optanon) {
          // Set consent
          Array.from(purposes).forEach((purpose) => {
            window.Optanon.setConsentProfile({ purposes: [purpose] });
          });

          window.Optanon.Close(
            /**
             * Calling the event creation with 1 second delay to give some extra
             * time for the banner to disappear. The Optanon.Close method closes the banner
             */
            setTimeout(
              () => window.dispatchEvent(new Event('OneTrust_Close')),
              1000
            )
          );
        }
      }

      // Adding event listener for event OneTrust_Close created above
      window.addEventListener('OneTrust_Close', () => {
        /**
         * Starting creation of the OT Sync notification window to inform
         * the user consent was synched between domain A and domain B
         */
        // TODO: needs to be our own brand-styled toast
        const div = document.createElement('div');
        div.setAttribute('id', 'ot-sync');
        div.setAttribute(
          'style',
          'bottom: 0.6rem;position:fixed;left: 4.5em;font-family:inherit;box-shadow:0 2px 14px 0 rgba(0,0,0,.15);padding:4px;border: 1px solid #010101;border-radius:8px;background-color:#FFFFFF;z-index:1000;'
        );
        if (document.querySelector('[id=onetrust-consent-sdk]')) {
          document.querySelector('[id=onetrust-consent-sdk]').appendChild(div);
        }
        const h = document.createElement('H2');
        h.setAttribute('id', 'ot-sync-title');
        h.setAttribute('style', 'font-size:.875em;font-weight:bold;');
        // Function to concatenate the string with both domain names and append it to the Sync notification window
        function printSyncInfo(syncText, coloredText, coloredText2) {
          syncText = syncText
            .split(coloredText)
            .join("<span style='color:#68b631;'>" + coloredText + '</span>');
          const syncText2 = syncText
            .split(coloredText2)
            .join("<span style='color:#68b631;'>" + coloredText2 + '</span>');
          div.appendChild(h);
          const title = document.querySelector('[id="ot-sync-title"]');
          if (title) {
            title.innerHTML = `${syncText2}`;
          }
        }
        // calling the function with the domain A variable and the current domain
        printSyncInfo(
          `Cookie Preferences synced between ${domain} and ${window.location.hostname}, you can update them by clicking on the shield`,
          domain,
          window.location.hostname
        );
        /**
         * Function to hide the sync notif window, notice it's divided in two,
         * the first part is setting the animation and the second part (setHidden)
         * is called with one second delay, because display = none stops the transition animation abruptly
         */
        function hideSyncNotif() {
          // @ts-expect-error ignore this
          document.querySelector('[id=ot-sync]').style.opacity = '0';
          // @ts-expect-error ignore this
          document.querySelector('[id=ot-sync]').style.visibility = 'hidden';
          // @ts-expect-error ignore this
          document.querySelector('[id=ot-sync]').style.transition =
            'visibility 0s 400ms, opacity 400ms linear';
          function setHidden() {
            // @ts-expect-error ignore this
            document.querySelector('[id=ot-sync]').style.display = 'none';
          }
          setTimeout(setHidden, 1000);
        }
        /**
         * We're calling the hideSyncNotif when the event OneTrust_Close is
         * created but with a 5 seconds delay so that the user can read it
         */
        setTimeout(hideSyncNotif, 5000);
      });
    }
  }

  onOneTrustLoaded() {
    this.setState({ oneTrustProviderLoaded: true })
  }

  render() {
    const { children } = this.props
    return (
      <Fragment>
        {children}
      </Fragment>
    )
  }
}

export default OneTrustWrapper




// WEBPACK FOOTER //
// ./src/utilities/analytics/OneTrustWrapper.js